document.querySelectorAll(".product-form").forEach((form) => {
  const variantInput = form.querySelector('input[name="id"]');
  const productJson = form.querySelector('[type="application/json"]');

  if (!variantInput || !productJson) return;

  let product;
  try {
    product = JSON.parse(productJson.textContent);
  } catch {
    return;
  }

  const optionInputs = Array.from(form.querySelectorAll("[data-product-option]"));

  const updateVariant = () => {
    const selectedOptions = optionInputs.map((input) => input.value);
    const variant = product.variants.find((item) => {
      return item.options.every((option, index) => option === selectedOptions[index]);
    });

    if (!variant) return;

    variantInput.value = variant.id;
    const submit = form.querySelector("[data-product-submit]");
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? "Add to Cart" : "Sold Out";
    }
  };

  optionInputs.forEach((input) => input.addEventListener("change", updateVariant));
});
